import React from "react";
import PredictionsOutcomeQuestion from "./predictionsOutcomeQuestion/predictionsOutcomeQuestion";
import { useIntl } from "react-intl";

import styles from "./styles.module.scss";

/**
 * PredictionQuestions59 - A functional component to render a list of prediction questions.
 *
 * This component accepts a list of questions, a heading, and a description as props
 * and renders each question using the PredictionsOutcomeQuestion component.
 *
 * @param {Object} props - The props passed to the component.
 * @param {Array<Object>} props.questions - The list of questions to be rendered.
 * @param {string} props.heading - The heading text for the question section.
 * @param {string} props.description - The description text for the question section.
 */
export const PredictionQuestions59 = (props) => {
  /**
   * Processes and renders each question in the props.questions array.
   *
   * @returns {Array<React.Component>} An array of PredictionsOutcomeQuestion components.
   */
  const processQuestions = () => {
    return props.questions.map((question) => (
      <PredictionsOutcomeQuestion {...question} />
    ));
  };
  const intl = useIntl();

  return (
    <div className={styles.predictions}>
      {/* Heading for the question section */}
      <h4 className={styles.heading}>
        {intl.formatMessage({
          id: props.heading,
          defaultMessage: props.heading,
          description: "",
        })}
      </h4>
      {/* Description for the question section */}
      <p>
        {intl.formatMessage({
          id: props.description,
          defaultMessage: props.description,
          description: "",
        })}
      </p>
      {/* Rendered list of prediction questions */}
      {processQuestions()}
    </div>
  );
};
